import { NavLink } from "react-router-dom";

interface Props {
  path: string;
  text: string;
  iconOn: string;
  iconOff: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

/**
 * メニューのボタン
 * @param root0 コンポーネントのプロップス
 */
export default function MenuButton({
  path = "",
  text = "",
  iconOn = "",
  iconOff = "",
  onClick,
}: Props) {
    const buttonStyle: React.CSSProperties = {
        fontSize: '2rem',
        fontWeight: 'bold',
        padding: '0.8rem 0.3rem',
        cursor: 'pointer',
        textDecoration: 'none',
        alignItems: 'center',
    }
    const imageStyle: React.CSSProperties = {
        width: '1rem',
        height: 'auto',
        margin: '0 0.4rem',
    }
  return (
    <div>
      <NavLink
        to={path}
        className={({ isActive }) => (isActive ? "color4" : "color3")}
        style={buttonStyle}
        onClick={(e) => onClick ? onClick(e) : {}}
        // eslint-disable-next-line react/no-children-prop
        children={({ isActive }) => (
          <>
            <img src={isActive ? iconOn : iconOff} alt="" style={imageStyle} />
            <span>{text}</span>
          </>
        )}
      />
    </div>
  );
}
